import api from '../utils/axiosConfig';

// Helper to handle API errors
const handleError = (error) => {
  if (error.response) {
    // Server responded with an error status code
    const errorResponse = {
      error: true,
      status: error.response.status,
      message: error.response.data.message || 'Server error occurred',
    };

    // Check if this is a Patreon subscription required error
    if (error.response.status === 403) {
      if (error.response.data.code === 'SUBSCRIPTION_REQUIRED' ||
          error.response.data.message?.includes('Patreon supporter')) {
        errorResponse.patreonRequired = true;
        errorResponse.code = 'SUBSCRIPTION_REQUIRED';
      }
    }
    
    return errorResponse;
  } else if (error.request) {
    // Request was made but no response received
    return {
      error: true,
      message: 'No response from server',
    };
  } else {
    // Error during request setup
    return {
      error: true,
      message: error.message,
    };
  }
};

// API call to check current user
const getCurrentUser = async () => {
  try {
    const response = await api.get('/api/auth/me');
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// Verify Patreon access
const verifyPatreonAccess = async () => {
  try {
    // Simple call to a protected endpoint that requires Patreon subscription
    const response = await api.get('/api/users/verify-patron');
    return response.data;
  } catch (error) {
    return Promise.reject(handleError(error));
  }
};

// Handle Patreon OAuth callback
const handleOAuthCallback = async (code) => {
  try {
    const response = await api.post('/api/auth/patreon/callback', { code });
    
    // Store token in memory if not using cookies
    if (response.data && response.data.token) {
      sessionStorage.setItem('authToken', response.data.token);
    }
    
    return {
      error: false,
      user: response.data.user,
    };
  } catch (error) {
    return handleError(error);
  }
};

// Logout user
const logout = async () => {
  try {
    // Call logout endpoint if it exists
    try {
      await api.post('/api/auth/logout');
    } catch (e) {
      // Ignore errors if the endpoint doesn't exist
      console.log('Logout endpoint may not exist:', e);
    }
    
    // Clear token from memory
    sessionStorage.removeItem('authToken');
    
    return {
      error: false,
      message: 'Logged out successfully',
    };
  } catch (error) {
    return handleError(error);
  }
};

// Check if token is still valid
const verifyToken = async () => {
  try {
    const response = await api.get('/api/auth/verify');
    return {
      error: false,
      valid: true,
      user: response.data
    };
  } catch (error) {
    return {
      error: true,
      valid: false,
      ...handleError(error)
    };
  }
};

// Generate object with auth methods
export const AuthService = {
  getCurrentUser,
  handleOAuthCallback,
  logout,
  verifyToken,
  verifyPatreonAccess
};

export default AuthService; 